import React, { useEffect, useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import Card from 'react-bootstrap/Card';
import Button from 'react-bootstrap/Button';

import { ECGResultsContainer } from '../../../common/types/ECGResults';

import { ECGMetricsTable } from './ECGMetricsTable';

interface ECGPreviewProps {
  show: boolean;
  onHide: () => void;
  results: ECGResultsContainer;
}

export const ECGPreview: React.FC<ECGPreviewProps> = ({
  show,
  onHide,
  results,
}) => {
  const [pdfUrl, setPdfUrl] = useState<string | null>(null);

  useEffect(() => {
    if (!show || !results.pdf) {
      return;
    }
    let url: string;
    fetch(`data:application/pdf;base64,${results.pdf}`)
      .then(r => r.blob())
      .then(b => {
        url = URL.createObjectURL(b);
        setPdfUrl(url);
      })
      .catch(e => console.error('Error converting PDF:', e));

    return () => {
      if (url) {
        URL.revokeObjectURL(url);
      }
    };
  }, [show, results.pdf]);

  const handleOpenFullPdf = () => {
    if (pdfUrl) {
      window.open(pdfUrl, '_blank');
    }
  };

  return (
    <Modal centered show={show} onHide={onHide} backdrop="static" size="xl">
      <Modal.Header closeButton>
        <Modal.Title>Wyniki EKG</Modal.Title>
      </Modal.Header>
      <Modal.Body className="d-flex gap-3 ecg-preview-content">
        <Card className="w-50">
          <Card.Body>
            <Card.Title>
              {results.results.findings && results.results.findings.trim()
                ? results.results.findings
                : '—'}
            </Card.Title>
            <ECGMetricsTable results={results.results} />
          </Card.Body>
        </Card>
        <Card className="w-50 h-100">
          {pdfUrl && (
            <>
              <iframe
                className="w-100 h-100"
                src={`${pdfUrl}#page=1&zoom=page-fit&toolbar=0&navpanes=0`}
                title="Podgląd PDF EKG"
              />
            </>
          )}
        </Card>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          Zamknij
        </Button>
        {pdfUrl && (
          <Button variant="primary" onClick={handleOpenFullPdf}>
            Otwórz wynik
          </Button>
        )}
      </Modal.Footer>
    </Modal>
  );
};
